import { render, staticRenderFns } from "./ManageFilesDescriptionMethodology.vue?vue&type=template&id=ff1c2282&scoped=true&"
import script from "./ManageFilesDescriptionMethodology.vue?vue&type=script&lang=js&"
export * from "./ManageFilesDescriptionMethodology.vue?vue&type=script&lang=js&"
import style0 from "./ManageFilesDescriptionMethodology.vue?vue&type=style&index=0&id=ff1c2282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1c2282",
  null
  
)

export default component.exports